define('helpers/make.displayname',['require','exports','module'],function(require, exports, module) {
  module.exports = function makeDisplayname(model, userPrincipalModel) {
    if (model.get('fullName').trim().length !== 0) {
      return model.get('fullName');
    }

    var fullName = userPrincipalModel.get('fullName');
    if (fullName && fullName.trim().length > 0) {
      return fullName;
    }

    var username = userPrincipalModel.get('username');
    if (username && username.length > 0) {
      return username;
    }

    return 'Current User';
  };
});

